import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Header from './Header';
import Footer from './Footer';
import Impressum from './Impressum';
import Register from './Register';
import Home from './Home';
import Confirm from './Confirm';
import About from './About';
import Usersettings from './Usersettings';
import User from './User';
import Login from './Login';
import Logout from './Logout';
import Pets from './Pets';
import Pet from './Pet';
import PateSearch from './Search';
import Request from './Request';
import Messages from './Messages';
import Loading from './Loading';
import NotFound from './NotFound';
import AGB from './AGB';
import PriceList from './PriceList';

import * as Actions from '../actions/actions';


class Routes extends Component {
  static getIsAuth() {
    return (
      <Switch>
        <Route exact path="/" component={() => <Redirect to="/pets/" />} />
        <Route path="/pet/:action/:petId?" component={Pet} />
        <Route path="/pets" component={Pets} />
        <Route path="/about" component={About} />
        <Route path="/home" component={Home} />
        <Route path="/user/:userId" component={User} />
        <Route path="/usersettings" component={Usersettings} />
        <Route path="/messages/:selectedRequestId?" component={Messages} />
        <Route path="/request/:userId" component={Request} />
        <Route path="/search" component={PateSearch} />
        <Route path="/login" component={() => <Redirect to="/" />} />
        <Route path="/logout" component={Logout} />
        <Route path="/confirm" component={() => <Redirect to="/pets/" />} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/agb" component={AGB} />
        <Route path="/priceList" component={PriceList} />
        <Route component={NotFound} />
      </Switch>);
  }

  static getIsNotAuth() {
    return (
      <Switch>
        <Route exact path="/" component={() => <Redirect to="/login" />} />
        <Route path="/confirm" component={Confirm} />
        <Route path="/register" component={Register} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/login" component={Login} />
        <Route path="/about" component={About} />
        <Route path="/logout" component={Home} />
        <Route path="/home" component={Home} />
        <Route path="/agb" component={AGB} />
        <Route path="/priceList" component={PriceList} />
        <Route component={Loading} />
      </Switch>);
  }

  static profileIsNotValid() {
    return (
      <Switch>
        <Route exact path="/" component={() => <Redirect to="/usersettings" />} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/about" component={About} />
        <Route path="/logout" component={Logout} />
        <Route path="/home" component={Home} />
        <Route path="/agb" component={AGB} />
        <Route path="/usersettings" component={Usersettings} />
        <Route path="/priceList" component={PriceList} />
        <Route path="/*" component={() => <Redirect to="/usersettings" />} />
        <Route component={Loading} />
      </Switch>);
  }

  static getEmailNotVerified() {
    return (
      <Switch>
        <Route exact path="/" component={() => <Redirect to="/home" />} />
        <Route path="/confirm" component={Confirm} />
        <Route path="/register" component={Register} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/Home" component={Home} />
        <Route path="/login" component={Login} />
        <Route path="/about" component={About} />
        <Route path="/agb" component={AGB} />
        <Route path="/priceList" component={PriceList} />
        <Route component={NotFound} />
      </Switch>);
  }

  static getLoadingPage() {
    return (
      <Switch>
        <Route component={Loading} />
      </Switch>);
  }

  constructor(props) {
    super(props);
    props.isAuthorized(props.uid);
  }

  render() {
    const {
      authVm: {
        emailVerified, uid
      },
      currentUserVm: {
        profileIsValid
      }
    } = this.props;

    if (uid !== undefined && emailVerified && profileIsValid === undefined) {
      this.props.getUser();
    }

    return (
      <BrowserRouter>
        <div className="wrapper">
          <Header />
          <section className="content">
            <div className="container">
              {uid !== undefined && emailVerified && profileIsValid && Routes.getIsAuth()}
              {uid !== undefined && emailVerified && profileIsValid === undefined && Routes.getLoadingPage()}
              {uid !== undefined && emailVerified && profileIsValid !== undefined && !profileIsValid && Routes.profileIsNotValid()}

              {uid === undefined && !emailVerified && Routes.getIsNotAuth()}
              {uid !== undefined && !emailVerified && Routes.getEmailNotVerified()}
            </div>
          </section>
          <Footer />
        </div>
      </BrowserRouter>);
  }
}

export default
connect(
  state => ({ ...state.currentUserReducer, ...state.authReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(Routes);



// WEBPACK FOOTER //
// ./src/pages/routes.js